<template lang="html">
  <div class="card">
    <div class="card-title" v-if="$slots['title']">
      <slot name="title"></slot>
    </div>
    <div class="card-top-left" v-if="$slots['top-left']">
      <slot name="top-left"></slot>
    </div>
    <div class="card-top-right" v-if="$slots['top-right']">
      <slot name="top-right"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.card {
  border: none !important;
  background: #fff;
  position: relative;
  display: block;
  // flex-direction: column;
  background-color: #fff;
  border-radius: 0;
  margin-bottom: 30px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);

  .card-title {
    margin: 0;
    & > * {
      padding: 0;
      font-family: font(title);
      font-weight: 300;
      color: gray(600);
      // font-size: size(3)*1.2;
      padding: 1em;
      margin: 0;
    }
  }
  .card-top-right {
    position: absolute;
    top: 1em;
    right: 1em;
  }
  .card-top-left {
    position: absolute;
    top: 1em;
    left: 1em;
  }
  &.card-user {
    display: flex;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/card.vue